// extracted by mini-css-extract-plugin
export default {"chip":"StatusTag_chip__GRJgQ","online":"StatusTag_online__6mwFE","offline":"StatusTag_offline__RHLzE"};